import { Log } from '@fanfanlo'
import { actionOpenAppUtils } from '../actions/app/action-open-app/IActionOpenApp.inft'
import { actionToAppMainPageUtils } from '../actions/app/to-app-main-page/IToAppMainPage.intf'
import { actionA11yNodeExecuteUtils } from '../actions/a11y/node-execute/node-execute'
import { actionNodeActionUtils } from '../actions/a11y/node-action/IActionNodeAction'
import { actionScriptUtils } from '../actions/script/script-action/IActionScript.inft'
import { actionShowFloatWindowUtils } from '../actions'

const fileLog = new Log(false, 'initActions_f')
fileLog.pause = true
fileLog.childrenPaused = true

/**
 * 初始化所有 Actions
 * 调用各个 actionUtils.init() 完成注册
 */
export function initActions() {

    actionOpenAppUtils.init()

    actionToAppMainPageUtils.init()

    actionA11yNodeExecuteUtils.init()

    actionNodeActionUtils.init()

    actionScriptUtils.init()

    actionShowFloatWindowUtils.init()

}
